import {columnWidth} from '../settings';

const calculateItems = (items, width) =>{

  items = setDimensions(items,width);

  let rows = calculatRows(items, width).map(row => {

    // set glyphs width
    if(row.glpyhs.length){
      let restColumns = Math.floor( (width - row.width) / columnWidth );
      for(let i=0; i<restColumns-1; i++){
        let index = row.glpyhs[i % row.glpyhs.length];
        row.items[index].dimension.width += columnWidth;
      }
    }

    // set glyphs height
    row.glpyhs.forEach( index =>{
      if(row.items[index+1] && row.items[index+1].type === "image"){
        row.items[index].dimension.height = row.items[index+1].dimension.height;
      }
      else if(row.items[index-1] && row.items[index-1].type === "image") {
        row.items[index].dimension.height = row.items[index-1].dimension.height;
      }
      else if(row.items[index-1]) {
        row.items[index].dimension.height = row.items[index-1].dimension.height;
      }
      else if(row.items[index+1]) {
        row.items[index].dimension.height = row.items[index+1].dimension.height;
      }
    })

    return row.items;
  });

  return [].concat.apply([], rows);
}

const setDimensions = (items, rowWidth) => {
  return items.map( item => {
    let width, ratio;
    if(item.type === 'project'){
      let project = projectWidthRatio(item);
      width = project.width;
      ratio = project.ratio;
    }
    else{
      width = item.width;
      ratio = item.ratio;
    }

    // For Mobile: full width or half width
    if(width > rowWidth){
      width = rowWidth;
      width = width - (width % columnWidth);
    }
    else if(width < rowWidth && rowWidth <= 500 ){
      width = rowWidth / 2;
      width = width - (width % columnWidth);
    }

    item.dimension.width = width;
    item.dimension.height = width * ratio[0] / ratio[1];
    return item;
  });
}

const projectWidthRatio = project => {
  let width, ratio;
  let {open, images, index} = project;
  if(project.isOpen){
    width = open.width;
    ratio = open.ratio;
  }
  else {
    width = images[index].width;
    ratio = images[index].ratio;
  }
  return {ratio, width}
}


const calculatRows = (items, rowWidth) => {
  let rows = [];
  let row = resetedRow();

  items.forEach( item => {
    let width = item.dimension.width;

    // newRow
    if(row.width + width > rowWidth){
      rows.push(row);
      row = resetedRow();
    }

    // addItem
    row.width += width;
    row.items.push(item);
    if(item.type === 'glyph'){
      row.glpyhs.push(row.items.length-1);
    }
  });

  //newRow
  if(row.items.length !== 0){
    rows.push(row);
    row = resetedRow();
  }

  return rows;
}

const resetedRow = () => {
  return {
    items: [],
    glpyhs: [],
    width: 0,
  };
}



export default calculateItems;


// WEBPACK FOOTER //
// ./src/utils/calculateItems.js